define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/html",
	"dojo/text!./StepSummaryItem.html",

	"csi/widget/SimpleTextWithTitle",
], function (declare, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, html, template) {

	const _Widget = declare([_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin], {
		templateString: template,

		// extension points
		countNode: null,
		stepActionNode: null,
		summaryInstanceNameNode: null,
		summaryTypeNode: null,

		/** @property {Widget} action - the step action widget */
		action: null,

		/** @property {string} count - the count based on all the nodes user selects  */
		count: "",

		/** @property {string} name - the name of the current processing node  */
		name: "",

		/** @property {number} type - the type of the current processing node */
		type: null,

		/** put the action widget in place */
		_setActionAttr: function (widget) {
			if (!widget) {
				return;
			}

			const { stepActionNode } = this;
			widget.placeAt(stepActionNode);
			html.setVisible(stepActionNode, true);
		},

		/**
		 * Set name
		 * @param {string} text
		 */
		_setNameAttr: function (text) {
			this.summaryInstanceNameNode.set("text", text);
		},

		/** set count */
		_setCountAttr: { node: "countNode", type: "innerText" },

		/** set type */
		_setTypeAttr: { node: "summaryTypeNode", type: "innerText" },
	});

	return _Widget;
});